import { render, staticRenderFns } from "./CaseConfigPermissionData.vue?vue&type=template&id=4ac73e5d"
import script from "./CaseConfigPermissionData.vue?vue&type=script&lang=js"
export * from "./CaseConfigPermissionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports